<ion-fab-button
  mode="md"
  [color]="background"
  class="fab-button-cart"
  (click)="onCartClick()"
>
  <ion-row class="row-content">
    <!-- * Gauge -->
    <ion-col size="4" class="ion-no-padding">
      <ng-container *ngIf="maximum > 0">
        <mwl-gauge
          class="getm-floating-gauge"
          [max]="maximum"
          [dialStartAngle]="dialStartAngle"
          [dialEndAngle]="dialEndAngle"
          [value]="position"
          [animated]="true"
          [animationDuration]="1"
          [showValue]="false"
        >
        </mwl-gauge>

        <ng-container *ngIf="position >= maximum">
          <ion-icon
            name="checkmark-sharp"
            color="getm-background-white"
            class="icon-checkmark"
            @fadeText
          ></ion-icon>
        </ng-container>
      </ng-container>

      <ion-icon
        name="getm-floating-cart-empty"
        [color]="iconColor"
        class="icon-cart"
      ></ion-icon>

      <ion-icon
        name="getm-cart-full-single"
        [color]="'getm-neutral-white'"
        class="icon-cart-full"
        [style.clip-path]="
          'inset(' + (100 - (position / maximum) * 100) + '% 0 0 0)'
        "
      ></ion-icon>
    </ion-col>

    <!-- * Price Text -->
    <ion-col size="8" class="ion-no-padding">
      <ion-label>
        <ion-text class="top-text" [color]="topTextColor">
          {{ topText }}
        </ion-text>
        <br />
        <ion-text class="bottom-text" [color]="bottomTextColor">
          {{
            summaryPrice.total_precio
              | currency : undefined : 'symbol' : '1.2-2'
          }}
        </ion-text>
      </ion-label>
    </ion-col>
  </ion-row>
</ion-fab-button>

<!-- * Bonus badge -->
<ng-container *ngIf="bonuses">
  <ion-avatar
    @reboundIn
    class="bg-bonus"
    [style.background]="'var(--ion-color-' + bonusBackground + ')'"
    [style.box-shadow]="
      '0px 4px 8px 0px rgba(var(--ion-color-' + background + '-rgb), 0.25)'
    "
    (click)="onCartClick()"
  >
    <ion-icon class="icon-bonus" name="getm-gift" [color]="bonusColor" />
  </ion-avatar>
  <!-- Partículas de confeti simuladas -->
  <div class="confeti-wrapper">
    <span class="particula p1"></span>
    <span class="particula p2"></span>
    <span class="particula p3"></span>
    <span class="particula p4"></span>
    <span class="particula p5"></span>
    <span class="particula p6"></span>
  </div>
</ng-container>
